<template>
  <div class="record">
    <div class="record-header border-bottom">
      <van-button size="small" :to="{ name: 'Track', query: { calcDate: currentMonth } }">当月统计</van-button>
      <div class="date" @click="visible = 'date'">
        <span>{{ currentMonth }}</span>
        <van-icon name="arrow-down" />
      </div>
    </div>
    <div class="record-panel">
      <template v-if="list.length">
        <div class="record-panel-item border-top border-bottom" v-for="(item, index) in list" :key="index">
          <div class="info">
            <span>{{ `${item.month}月${item.day}` }}</span>
            <span>{{ `${item.week}` }}</span>
          </div>
          <div class="extra" @click="$router.push({ name: 'RecordDay', query: { date: `${item.year}-${item.month}-${item.day}` } })">
            <span>{{ `${item.submitNum}人提交` }}</span>
            <van-icon name="arrow" />
          </div>
        </div>
      </template>
      <van-empty v-else description="暂无数据" />
    </div>
    <!-- 日期选择器 -->
    <MonthPicker
      :showDatePicker="visible === 'date'"
      :currentDate.sync="currentMonth"
      @changeDate="params = { ...params, ...$event }"
      @update:showDatePicker="visible = ''"
    />
  </div>
</template>

<script>
import { currentMonth, getMonthStartTime, getMonthEndTime } from '@/utils'
import MonthPicker from '@/components/date/monthPicker'
import { countTrackList } from '@/api/track'
export default {
  name: 'RecordList',
  components: { MonthPicker },
  data() {
    return {
      currentMonth,
      visible: '',
      params: {
        startTime: getMonthStartTime(currentMonth),
        endTime: getMonthEndTime(currentMonth)
      },
      page: {
        page: 1,
        count: 1000
      },
      list: []
    }
  },
  watch: {
    params: {
      handler(newVal) {
        const params = {
          ...newVal,
          page: 1,
          count: this.page.count
        };
        this.getRecordList(params, true);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getRecordList(query) {
      // 获取跟进记录列表
      countTrackList(query).then((res) => {
        if (res.errcode === 0) {
          this.list = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .record { background-color: #fff; min-height: 100vh;
    &-header { display: flex; justify-content: space-between; align-items: center; padding: 10px 16px; font-size: 14px; color: #333;
      .van-button { background-color: transparent; border: none; color: #02A7F0; height: 100%; font-size: 14px; }
      .date { display: flex; align-items: center;
        .van-icon-arrow-down { margin-left: 10px; }
      }
    }
    &-panel { margin-top: 15px;
      &-item { display: flex; justify-content: space-between; align-items: center; padding: 10px 16px; color: #333; font-size: 14px;
        .info {
          span { &:first-child { margin-right: 10px; } }
        }
        .extra { display: flex; align-items: center;
          .van-icon { margin-left: 10px; }
        }
      }
    }
  }
</style>